import { NgModule } from '@angular/core';

import { DecimalPipe } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { routing, appRoutingProviders } from './app.routing';
import { AuthzoneComponent } from './authzone/authzone.component';
import { authInterceptorProviders } from './services/auth-user-service/auth.interceptor';
import { ClientsSocisModule } from './clientsSocis/clientssocis.module';
import { ContactesModule } from './contactes/contactes.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ProjectsSearchModule } from './projects-search/projects-search.module';
import { ManageProjectModule } from './manage-project/manage-project.module';
import { AuthzoneModule } from './authzone/authzone.module';
import { LoginModule } from './login/login.module';
import { SeguimentTecnicModule } from './seguiment-tecnic-cercador/seguiment-tecnic.module';
import { DialogSeguimentTecnic } from './dialog/seguiment-tecnic/dialog.component.seguiment-tecnic';
import { DialogFactures } from './dialog/factures/dialog.component.factures';
import { DialogFacturesReb } from './dialog/factures-reb/dialog.component.factures-reb';
import { DialogDocuments } from './dialog/documents/dialog.component.documents';
import { DialogInnovacio } from './dialog/innovacio/dialog.component.innovacio';
import { DialogOportunitats } from './dialog/oportunitats/dialog.component.oportunitats';
import { DialogNotes } from './dialog/notes/dialog.component.notes';
import { DialogNotesContactes } from './dialog/notes_contactes/dialog.component.notes_contactes';
import { DialogDedicatsMes } from './dialog/dedicats-mes/dialog.component.dedicats-mes';
import { DialogFitxes } from './dialog/fitxes/dialog.component.fitxes';
import { DialogAvaluar } from './dialog/avaluar/dialog.component.avaluar';
import { DialogTicketing } from './dialog/ticketing/dialog.component.ticketing';
import { UtesDlgModule } from './dialog/utes/utes.module';
import { DialogDedicats } from './dialog/dedicats/dialog.component.dedicats';
import { DialogClientsSocis } from './dialog/clientssocis/dialog.component.clientssocis';
import { DialogContactes } from './dialog/contactes/dialog.component.contactes';
import { AiSearchComponent } from './chatgpt-ai/chatgpt-ai-search.component';
import { DialogManageInvoiceComponent } from './dialog/manage-invoice/dialog.manage-invoice.component';
import { CurrencyDialogComponent } from './dialog/currencies/currency-dialog.component';
import { CalendarsModule } from './calendars/calendars.module';
import { ManageUsersModule } from './manage-users/manage-users.module';
import { ReportsModule } from './reports/reports.module';
import { ManageCurriculumModule } from './manage-curriculum/manage-curriculum.module';
import { ManageCalendarModule } from './manage-calendar/manage-calendar.module';
import { DocumentsSearchModule } from './documents-cercador/documents-cercador.module';
import { AuthUserService } from './services/auth-user-service/auth-user.service';
import { ManageInvoiceModule } from './manage-invoice/manage-invoice.module';
import { ManageRebInvoiceModule } from './manage-invoice-reb/manage-invoice-reb.module';
import { InvoicesModule } from './invoices/invoices.module';
import { InvoicesRebModule } from './invoices-reb/invoices-reb.module';
import { TicketingModule } from './ticketing-cercador/ticketing.module';
import { OportunitatsModule } from './oportunitats/oportunitats.module';
import { UtesModule } from './utes/utes.module';
import { NotesModule } from './notes/notes.module';
import { ConcursosModule } from './concursos/concursos.module';
import { DedicacionsModule } from './dedicacions/dedicacions.module';
import { FacturesSearchModule } from './factures-cercador/factures-cercador.module';
import { FacturesRebSearchModule } from './factures-reb-cercador/factures-reb-cercador.module';
import { HourControlModule }   from './hour-control/hour-control.module';
import { TwoDigitDecimaNumberDirective } from './pipes/digit-decim-number.directive';

import { AngularMaterialModule } from './angular-material.module';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { QuillModule } from 'ngx-quill';

export function tokenGetterFactory(){
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [
    AppComponent,
    DialogSeguimentTecnic,
    DialogTicketing,
    DialogFacturesReb,
    DialogFactures,
    DialogDocuments,
    DialogClientsSocis,
    DialogInnovacio,
    DialogOportunitats,
    DialogNotes,
    DialogDedicats,
    DialogContactes,
    DialogNotesContactes,
    DialogFitxes,
    DialogAvaluar,
    DialogManageInvoiceComponent,
    DialogDedicatsMes,
    AiSearchComponent,
    CurrencyDialogComponent,
    TwoDigitDecimaNumberDirective
  ],
  imports: [
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LoginModule,
    AuthzoneModule,
    ClientsSocisModule,
    AngularMaterialModule,
    ContactesModule,
    DashboardModule,
    ProjectsSearchModule,
    ManageProjectModule,
    SeguimentTecnicModule,
    TicketingModule,
    FormsModule,
    CalendarsModule,
    ReportsModule,
    ManageUsersModule,
    ManageCurriculumModule,
    ManageCalendarModule,
    DocumentsSearchModule,
    ManageInvoiceModule,
    ManageRebInvoiceModule,
    InvoicesModule,
    InvoicesRebModule,
    OportunitatsModule,
    UtesModule,
    UtesDlgModule,
    NotesModule,
    ConcursosModule,
    FacturesSearchModule,
    FacturesRebSearchModule,
    HourControlModule,
    routing,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    QuillModule.forRoot({
      modules: {
        syntax: false,
        toolbar: [['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'bullet' }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        [ 'link' ],
        [ 'clean' ]   
      ]       // toggled buttons
     }
    })
  ],
  providers: [
    authInterceptorProviders,
    AuthUserService,
    DecimalPipe,
    appRoutingProviders,
    {useClass: HashLocationStrategy, provide: LocationStrategy}
  ],
  exports: [ TranslateModule ],
  bootstrap: [ AppComponent ],
  entryComponents: [ ]
})
export class McritGestioModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "../../assets/i18n/", ".json");
}